export {default} from './Avatar';
export * from './types';



// WEBPACK FOOTER //
// ./src/components/Avatar/index.ts